module.exports = __webpack_public_path__ + "static/media/dash-disable.6f59dd04.png";